/* eslint-disable */

const featuresByPlan = {
    annual: {
        planPrices: [
            {
                label: 'Free',
                price: 0,
                unit: 'month',
                upgradeLink: '/apps/presentations?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=free_annually',
                permissionKey: 'free',
                'smaller-price': 0,
                maxParticipants: 15,
                description: 'Includes:',
                listFeature : ["Up to 5 quiz questions", 'Import PowerPoint / PDF files', 'Collaborative editing']
            },
            {
                label: 'Essential',
                price: 10,
                'smaller-price': 75,
                billingYearly : 129,

                unit: 'month',
                upgradeLink: '/apps/upgrade/essential-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=essential_annually',
                permissionKey: 'essentialYearly',
                planKey : 'essential-yearly',
                description: 'All Free features, plus:',
                maxParticipants: 50,
                listFeature: ["Unlimited interactive questions", "Collect audience info", "Export results to Excel", "Export slides as PDF / JPG", "Custom background"]
            },
            {
                label: 'Plus',
                price: 14,
                'smaller-price': 75,
                billingYearly : 177,
                unit: 'month',
                upgradeLink: '/apps/upgrade/plus-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=plus_annually',
                permissionKey: 'plusYearly',
                planKey: 'plus-yearly',
                description: 'All Free features, plus:',
                maxParticipants: 200,

                listFeature: ["Unlimited interactive questions", "Collect audience info", "Export results to Excel", "Export slides as PDF / JPG", "Custom background"]
            },
            {
                label: 'Pro',
                price: 21,
                'smaller-price': 75,
                officialPrice: 21.75,
                billingYearly : 261,
                unit: 'month',
                upgradeLink: '/apps/upgrade/pro-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=pro_annually',
                permissionKey: 'proYearly',
                planKey: 'pro-yearly',
                description: 'All Plus features, plus:',
                maxParticipants: "10,000",
                listFeature: ["Custom logo", "Custom participant link", "Audio, font library", "Audience questions moderation (Q&A)", "Authenticate audience before events", "Video call with audience"]
            },
        ],
        plansDropdown: [
            { plan: 'monthly', title: 'Monthly plans' },
            { plan: 'educational', title: 'Educational plans' },
        ],
        participation: {
            'max-participants': {
                title: 'Audience size',
                tooltipVal: 'Maximum number of live participants that can join your presentation at the same time',
                planVal: ['15', '50', '200', '10,000'],
            },
            'audience-admission': {
                title: 'Audience info collection',
                tooltipVal: 'Collect audience information (name, email,...) at the start of the presentation.',
                planVal: [false, true, true, true],
            },
            'audience-authentication': {
                title: 'Audience authentication',
                tooltipVal: 'Participants must enter the unique codes you provide, to be able to join the presentation.',
                planVal: [false, false, false, true],
            },

        },
        'Data Export': {
            'excel-file': {
                title: 'Excel files',
                tooltipVal: 'Export full data from your presentation, including all audience data and responses, to Excel files for deeper analysis',
                planVal: [false, true, true, true],
            },
            'pdf-jpg-exports': {
                title: 'PDF / JPG files',
                tooltipVal: 'Export your slides, including audience responses, into a PDF document, or a set of JPG images',
                planVal: [false, true, true, true],
            },
        },
        'Branding & Customisation': {
            'custom-logo': {
                title: 'Logo',
                tooltipVal: 'You can add your own logo (to replace default AhaSlides logo) on your slides and on your audience\'s phone screen',
                planVal: [false, false, false, true],
            },
            'designer-fonts': {
                title: 'Fonts library',
                tooltipVal: 'Have access to a range of beautiful designer fonts (including special fonts for Arabic and Thai)',
                planVal: [false, false, false, true],
            },
            'audio-tracks': {
                title: 'Audio',
                tooltipVal: 'Add audio tracks that are playable by both the presenter and the audience on any slide',
                planVal: [false, false, false, true],
            },
            'custom-link': {
                title: 'Participant link',
                tooltipVal: 'Set a short, memorable link for your presentation, so that your participants can easily join in',
                planVal: [false, false, false, true],
            },
            'custom-backgrounds': {
                title: 'Background image',
                tooltipVal: 'Change text colour, background colour and background images to make your slides truly yours',
                planVal: [false, true, true, true],
            },
        },
        'Interactive Presentation': {
            'unlimited-quiz': {
                title: 'Unlimited Quiz',
                tooltipVal: 'Add fun (or competitive) Quiz games to your presentation to make it even more engaging',
                planVal: ['5 questions', true, true, true],
            },
            'unlimited-polls-word-clouds': {
                title: 'Unlimited Polls & Word Clouds',
                tooltipVal: 'Including Multiple Choice, Image Choice, Open Ended, Scales, Word Cloud questions',
                planVal: ['2 questions', true, true, true],
            },
            brainstorming: {
                title: 'Brainstorming',
                tooltipVal: 'Let everyone submit their ideas and vote for their favourite',
                planVal: [false, true, true, true],
            },
            'spinner-wheel': {
                title: 'Spinner Wheel',
                tooltipVal: 'Fun way to randomly pick a winner or an idea',
                planVal: [true, true, true, true],
            },
            'unlimited-qa': {
                title: 'Q&A',
                tooltipVal: 'Crowdsource the best questions from your audience',
                planVal: [true, true, true, true],
            },
            'qna-moderation': {
                title: 'Q&A moderation',
                tooltipVal: 'Moderate audience questions before displaying on the screen in Q&A activity.',
                planVal: [false, false, false, true],
            },
            'ai-generator': {
                title: 'AI Slide Generator',
                tooltipVal: 'Effortlessly generate engaging slides tailored to your needs with AI assistance.',
                planVal: [true, true, true, true],
            },
            'collaborative-editing': {
                title: 'Collaborative editing',
                tooltipVal: 'Let your friends and colleagues edit your presentations with you',
                planVal: [true, true, true, true],
            },
            'multilanguage-support': {
                title: 'Multilanguage support',
                tooltipVal: 'English, Deutsch, Español, Français, Italiano, 日本語, Nederlands, Português, Türkçe, Tiếng Việt',
                planVal: [true, true, true, true],
            },
            'powerpoint-pdf-import': {
                title: 'PowerPoint / PDF import',
                tooltipVal: 'Import your existing PPT, PPTX, and PDF presentation files to your AhaSlides presentation',
                planVal: [true, true, true, true],
            },
            'video-call': {
                title: 'Video call',
                tooltipVal: 'Video call any participant and show the conversation on your screen.',
                planVal: [false, false, false, true],
            },

        },

    },
    monthly: {
        planPrices: [
            {
                label: 'Free',
                price: 0,
                unit: 'month',
                upgradeLink: '/apps/presentations?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=free_monthly',
                permissionKey: 'free',
                maxParticipants: 15,
                'smaller-price': 0,
                description: 'Includes:',
                listFeature : ["Up to 5 quiz questions", 'Import PowerPoint / PDF files', 'Collaborative editing']
            },
            {
                label: 'Essential',
                price: 32,
                'smaller-price': 65,
                unit: 'month',
                payYearlySave : 16,

                permissionKey: 'essentialMonthly',
                planKey: 'essential-monthly',
                upgradeLink: '/apps/upgrade/essential-monthly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=essential_monthly',
                description: 'All Free features, plus:',
                maxParticipants: 50,
                listFeature: ["Unlimited interactive questions", "Collect audience info", "Export results to Excel", "Export slides as PDF / JPG", "Custom background"]
            },
            {
                label: 'Plus',
                price: 44,
                'smaller-price': 65,
                payYearlySave : 22,

                unit: 'month',
                planKey: 'plus-monthly',
                upgradeLink: '/apps/upgrade/plus-monthly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=plus_monthly',
                permissionKey: 'plusMonthly',
                description: 'All Free features, plus:',
                maxParticipants: 200,
                listFeature: ["Unlimited interactive questions", "Collect audience info", "Export results to Excel", "Export slides as PDF / JPG", "Custom background"]
            },
            {
                label: 'Pro',
                price: 67,
                'smaller-price':65,
                payYearlySave : 35,
                unit: 'month',
                planKey: 'pro-monthly',
                upgradeLink: '/apps/upgrade/pro-monthly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=pro_monthly',
                permissionKey: 'proMonthly',
                description: 'All Plus features, plus:',
                maxParticipants: "10,000",
                listFeature: ["Custom logo", "Custom participant link", "Audio, font library", "Audience questions moderation (Q&A)", "Authenticate audience before events", "Video call with audience"]
            },
        ],
        plansDropdown: [
            { plan: 'annual', title: 'Annual plans' },
            { plan: 'educational', title: 'Educational plans' },
        ],
        participation: {
            'max-participants': {
                title: 'Audience size',
                tooltipVal: 'Maximum number of live participants that can join your presentation at the same time',
                planVal: ['15', '50', '200', '10,000'],
            },
            'audience-admission': {
                title: 'Audience info collection',
                tooltipVal: 'Collect audience information (name, email,...) at the start of the presentation.',
                planVal: [false, true, true, true],
            },

            'audience-authentication': {
                title: 'Audience authentication',
                tooltipVal: 'Participants must enter the unique codes you provide, to be able to join the presentation.',
                planVal: [false, false, false, true],
            },

        },
        'Data Export': {
            'Excel file': {
                title: 'Excel files',
                tooltipVal: 'Export full data from your presentation, including all audience data and responses, to Excel files for deeper analysis',
                planVal: [false, true, true, true],
            },
            'pdf-jpg-exports': {
                title: 'PDF / JPG files',
                tooltipVal: 'Export your slides, including audience responses, into a PDF document, or a set of JPG images',
                planVal: [false, true, true, true],
            },
        },
        'Branding & Customisation': {
            'custom-logo': {
                title: 'Logo',
                tooltipVal: 'You can add your own logo (to replace default AhaSlides logo) on your slides and on your audience\'s phone screen',
                planVal: [false, false, false, true],
            },
            'designer-fonts': {
                title: 'Fonts library',
                tooltipVal: 'Have access to a range of beautiful designer fonts (including special fonts for Arabic and Thai)',
                planVal: [false, false, false, true],
            },
            'audio-tracks': {
                title: 'Audio',
                tooltipVal: 'Add audio tracks that are playable by both the presenter and the audience on any slide',
                planVal: [false, false, false, true],
            },
            'custom-link': {
                title: 'Participant link',
                tooltipVal: 'Set a short, memorable link for your presentation, so that your participants can easily join in',
                planVal: [false, false, false, true],
            },
            'custom-backgrounds': {
                title: 'Background image',
                tooltipVal: 'Change text colour, background colour and background images to make your slides truly yours',
                planVal: [false, true, true, true],
            },
        },
        'Interactive Presentation': {
            'unlimited-quiz': {
                title: 'Unlimited Quiz',
                tooltipVal: 'Add fun (or competitive) Quiz games to your presentation to make it even more engaging',
                planVal: ['5 questions', true, true, true],
            },
            'unlimited-polls-word-clouds': {
                title: 'Unlimited Polls & Word Clouds',
                tooltipVal: 'Including Multiple Choice, Image Choice, Open Ended, Word Cloud questions',
                planVal: ['2 questions', true, true, true],
            },
            brainstorming: {
                title: 'Brainstorming',
                tooltipVal: 'Let everyone submit their ideas and vote for their favourite',
                planVal: [false, true, true, true],
            },
            'spinner-wheel': {
                title: 'Spinner Wheel',
                tooltipVal: 'Fun way to randomly pick a winner or an idea',
                planVal: [true, true, true, true],
            },
            'unlimited-qa': {
                title: 'Q&A',
                tooltipVal: 'Crowdsource the best questions from your audience',
                planVal: [true, true, true, true],
            },
            'qna-moderation': {
                title: 'Q&A moderation',
                tooltipVal: 'Moderate audience questions before displaying on the screen in Q&A activity.',
                planVal: [false, false, false, true],
            },
            'ai-generator': {
                title: 'AI Slide Generator',
                tooltipVal: 'Effortlessly generate engaging slides tailored to your needs with AI assistance.',
                planVal: [true, true, true, true],
            },

            'collaborative-editing': {
                title: 'Collaborative editing',
                tooltipVal: 'Let your friends and colleagues edit your presentations with you',
                planVal: [true, true, true, true],
            },
            'multilanguage-support': {
                title: 'Multilanguage support',
                tooltipVal: 'English, Deutsch, Español, Français, Italiano, 日本語, Nederlands, Português, Türkçe, Tiếng Việt',
                planVal: [true, true, true, true],
            },
            'powerpoint-pdf-import': {
                title: 'PowerPoint / PDF import',
                tooltipVal: 'Import your existing PPT, PPTX, and PDF presentation files to your AhaSlides presentation',
                planVal: [true, true, true, true],
            },
            'video-call': {
                title: 'Video call',
                tooltipVal: 'Video call any participant and show the conversation on your screen.',
                planVal: [false, false, false, true],
            },

        },
    },
    'one-time': {
        updateLink: [
            {
                url: '/apps/upgrade/one-time-mini?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=one_time_mini',
                permissionKey: 'oneTimeMini',
            },
            {
                url: '/apps/upgrade/one-time-small?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=one_time_small',
                permissionKey: 'oneTimeSmall',
            },
            {
                url: '/apps/upgrade/one-time-medium?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=one_time_medium',
                permissionKey: 'oneTimeMedium',
            },
            {
                url: '/apps/upgrade/one-time-large?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=one_time_large',
                permissionKey: 'oneTimeLarge',
            },
        ],
        planPrices: [
            {
                label: 'Mini',
                price: 4,
                'smaller-price': 95,
                unit: 'event',
            },
            {
                label: 'Small',
                price: 10,
                'smaller-price': 95,
                unit: 'event',
            },
            {
                label: 'Medium',
                price: 26,
                'smaller-price': 95,
                unit: 'event',
            },
            {
                label: 'Large',
                price: 35,
                'smaller-price': 95,
                unit: 'event',
            },
        ],
        plansDropdown: [
            { plan: 'monthly', title: 'Monthly plans' },
            { plan: 'annual', title: 'Annual plans' },
            { plan: 'educational', title: 'Educational plans' },
        ],
        participation: { // [mini, small, medium, large]
            'max-participants': {
                title: 'Audience size',
                tooltipVal: 'Maximum number of live participants that can join your presentation at the same time',
                planVal: ['15', '30', '100', '1,000'],
            },
            'custom-link': {
                title: 'Custom link',
                tooltipVal: 'Set a short, memorable link for your presentation, so that your participants can easily join in',
                planVal: [true, true, true, true],
            },
            'qr-code': {
                title: 'QR code',
                tooltipVal: 'Have an unique QR code to include on your slides, printouts, event tickets..',
                planVal: [true, true, true, true],
            },
            'audience-authentication': {
                title: 'Audience authentication',
                tooltipVal: 'Participants must enter the unique codes you provide, to be able to join the presentation.',
                planVal: [false, false, false, true],
            },
            'video-call': {
                title: 'Video call',
                tooltipVal: 'Video call any participant and show the conversation on your screen.',
                planVal: [false, false, false, true],
            },
        },
        data: {
            'data-exports': {
                title: 'Data exports',
                tooltipVal: 'Export full data from your presentation, including all audience data and responses, to Excel files for deeper analysis',
                planVal: [true, true, true, true],
            },
            'pdf-jpg-exports': {
                title: 'PDF / JPG exports',
                tooltipVal: 'Export your slides, including audience responses, into a PDF document, or a set of JPG images',
                planVal: [true, true, true, true],
            },
        },
        customisation: {
            'custom-logo': {
                title: 'Custom logo',
                tooltipVal: 'You can add your own logo (to replace default AhaSlides logo) on your slides and on your audience\'s phone screen',
                planVal: [false, false, false, false],
            },
            'designer-fonts': {
                title: 'Designer fonts',
                tooltipVal: 'Have access to a range of beautiful designer fonts (including special fonts for Arabic and Thai)',
                planVal: [true, true, true, true],
            },
            'custom-backgrounds': {
                title: 'Custom backgrounds',
                tooltipVal: 'Change text colour, background colour and background images to make your slides truly yours',
                planVal: [true, true, true, true],
            },
            'audio-tracks': {
                title: 'Audio tracks',
                tooltipVal: 'Add audio tracks that are playable by both the presenter and the audience on any slide',
                planVal: [true, true, true, true],
            },
        },

    },
    educational: {
        planPrices: [
            {
                label: 'Free',
                price: 0,
                'smaller-price': 0,
                unit: 'month',
                maxParticipants: 15,

                upgradeLink: '/apps/presentations?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=free_edu',
                permissionKey: 'free',
                description: 'Includes:',
                listFeature: ["Up to 5 quiz questions", 'Import PowerPoint / PDF files', 'Collaborative editing']

            },
            {
                label: 'Edu Small',
                price: 3,
                billingYearly : 47.4,
                'smaller-price': 95,
                unit: 'month',
                maxParticipants: 25,
                planKey: 'edu-small-yearly',
                upgradeLink: '/apps/upgrade/edu-small-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=edu_small',
                permissionKey: 'eduSmallYearly',
                description: 'All Free features, plus:',
                listFeature: ["Unlimited interactive questions", "Collect audience info", "Export results to Excel", "Export slides as PDF / JPG", "Custom background"]
            },
            {
                label: 'Edu Medium',
                price: 7,
                billingYearly : 88.2,
                'smaller-price': 35,
                unit: 'month',
                maxParticipants: 50,
                planKey: 'edu-medium-yearly',
                upgradeLink: '/apps/upgrade/edu-medium-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=edu_medium',
                permissionKey: 'eduMediumYearly',
                description: 'All Free features, plus:',
                listFeature: ["Unlimited interactive questions", "Collect audience info", "Export results to Excel", "Export slides as PDF / JPG", "Custom background"]
            },
            {
                label: 'Edu Large',
                price: 10,
                'smaller-price': 35,
                billingYearly : 124.2,
                unit: 'month',
                planKey: 'edu-large-yearly',
                upgradeLink: '/apps/upgrade/edu-large-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=edu_large',
                permissionKey: 'eduLargeYearly',
                description: 'All Edu Medium features, plus:',
                maxParticipants: "200",
                listFeature: ["Audience questions moderation (Q&A)", "Authenticate audience before events","Video call with audience"]
            },

        ],
        plansDropdown: [
            { plan: 'monthly', title: 'Monthly plans' },
            { plan: 'annual', title: 'Annual plans' },
        ],
        participation: {
            'max-participants': {
                title: 'Audience size',
                tooltipVal: 'Maximum number of live participants that can join your presentation at the same time',
                planVal: ['15', '25', '50', '200'],
            },
            'audience-admission': {
                title: 'Audience info collection',
                tooltipVal: 'Collect audience information (name, email,...) at the start of the presentation.',
                planVal: [false, true, true, true],
            },
            'audience-authentication': {
                title: 'Audience authentication',
                tooltipVal: 'Participants must enter the unique codes you provide, to be able to join the presentation.',
                planVal: [false, false, false, true],
            },

        },
        'Data export': {
            'excel-file': {
                title: 'Excel files',
                tooltipVal: 'Export full data from your presentation, including all audience data and responses, to Excel files for deeper analysis',
                planVal: [false, true, true, true],
            },
            'pdf-jpg-exports': {
                title: 'PDF / JPG files',
                tooltipVal: 'Export your slides, including audience responses, into a PDF document, or a set of JPG images',
                planVal: [false, true, true, true],
            },
        },
        'Branding & Customisation': {
            'custom-logo': {
                title: 'Logo',
                tooltipVal: 'You can add your own logo (to replace default AhaSlides logo) on your slides and on your audience\'s phone screen',
                planVal: [false, false, false, false],
            },
            'designer-fonts': {
                title: 'Fonts library',
                tooltipVal: 'Have access to a range of beautiful designer fonts (including special fonts for Arabic and Thai)',
                planVal: [false, false, false, false],
            },
            'audio-tracks': {
                title: 'Audio',
                tooltipVal: 'Add audio tracks that are playable by both the presenter and the audience on any slide',
                planVal: [false, false, false, false],
            },
            'custom-link': {
                title: 'Participant link',
                tooltipVal: 'Set a short, memorable link for your presentation, so that your participants can easily join in',
                planVal: [false, false, false, false],
            },
            'custom-backgrounds': {
                title: 'Background image',
                tooltipVal: 'Change text colour, background colour and background images to make your slides truly yours',
                planVal: [false, true, true, true],
            },
        },
        'Interactive Presentation': {
            'unlimited-quiz': {
                title: 'Unlimited Quiz',
                tooltipVal: 'Add fun (or competitive) Quiz games to your presentation to make it even more engaging',
                planVal: ['5 questions', true, true, true],
            },
            'unlimited-polls-word-clouds': {
                title: 'Unlimited Polls & Word Clouds',
                tooltipVal: 'Including Multiple Choice, Image Choice, Open Ended, Word Cloud questions',
                planVal: ['2 questions', true, true, true],
            },
            brainstorming: {
                title: 'Brainstorming',
                tooltipVal: 'Let everyone submit their ideas and vote for their favourite',
                planVal: [false, true, true, true],
            },
            'spinner-wheel': {
                title: 'Spinner Wheel',
                tooltipVal: 'Fun way to randomly pick a winner or an idea',
                planVal: [true, true, true, true],
            },
            'unlimited-qa': {
                title: 'Q&A',
                tooltipVal: 'Crowdsource the best questions from your audience',
                planVal: [true, true, true, true],
            },
            'qna-moderation': {
                title: 'Q&A moderation',
                tooltipVal: 'Moderate audience questions before displaying on the screen in Q&A activity.',
                planVal: [false, false, false, true],
            },
            'ai-generator': {
                title: 'AI Slide Generator',
                tooltipVal: 'Effortlessly generate engaging slides tailored to your needs with AI assistance.',
                planVal: [true, true, true, true],
            },

            'collaborative-editing': {
                title: 'Collaborative editing',
                tooltipVal: 'Let your friends and colleagues edit your presentations with you',
                planVal: [true, true, true, true],
            },
            'multilanguage-support': {
                title: 'Multilanguage support',
                tooltipVal: 'English, Deutsch, Español, Français, Italiano, 日本語, Nederlands, Português, Türkçe, Tiếng Việt',
                planVal: [true, true, true, true],
            },
            'powerpoint-pdf-import': {
                title: 'PowerPoint / PDF import',
                tooltipVal: 'Import your existing PPT, PPTX, and PDF presentation files to your AhaSlides presentation',
                planVal: [true, true, true, true],
            },
            'video-call': {
                title: 'Video call',
                tooltipVal: 'Video call any participant and show the conversation on your screen.',
                planVal: [false, false, false, true],
            },

        },
    },
};
export default featuresByPlan
